import type { SVGProps } from 'react';
const DawnFlagDM = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-DM_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g clipRule="evenodd" mask="url(#dawn-flag-DM_svg__a)">
      <path fill="#108753" fillRule="evenodd" d="M0 6.4h22V0H0zM0 16h22V9.6H0z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M12.571 16H9.43V9.6H0V6.4h9.429V0h3.142v6.4H22v3.2h-9.429z"
      />
      <path
        fill="#262626"
        fillRule="evenodd"
        d="M11.524 16h-1.048V8.533H0V7.467h10.476V0h1.048v7.467H22v1.066H11.524z"
      />
      <path
        fill="#FCD449"
        fillRule="evenodd"
        d="M10.476 16H9.43V7.467H0V6.4h9.429V0h1.047v6.4H22v1.067H10.476z"
      />
      <path
        fill="url(#dawn-flag-DM_svg__b)"
        fillRule="evenodd"
        d="M11 11.733c2.025 0 3.666-1.671 3.666-3.733S13.025 4.267 11 4.267 7.333 5.938 7.333 8 8.975 11.733 11 11.733"
      />
      <path
        stroke="#0E673F"
        strokeDasharray="0.67 2.67"
        strokeLinecap="round"
        strokeWidth={1.333}
        d="M11 10.667c1.446 0 2.619-1.194 2.619-2.667s-1.173-2.667-2.62-2.667C9.554 5.333 8.382 6.527 8.382 8S9.553 10.667 11 10.667Z"
      />
      <path
        fill="#0E673F"
        fillRule="evenodd"
        d="M11 9.067c.578 0 .524-.478.524-1.067 0-.59.054-1.067-.524-1.067s-.524.478-.524 1.067c0 .59-.055 1.067.524 1.067"
      />
    </g>
    <defs>
      <linearGradient
        id="dawn-flag-DM_svg__b"
        x1={7.333}
        x2={7.333}
        y1={4.267}
        y2={11.733}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E02C42" />
        <stop offset={1} stopColor="#D22036" />
      </linearGradient>
    </defs>
  </svg>
);
export default DawnFlagDM;
